import { get, post } from "../../data/api";

export async function getModerationReports(status = "", page = 1, pageSize = 50) {
    const params = new URLSearchParams();
    if (status) {
        params.set("status", status);
    }
    params.set("page", String(page));
    params.set("pageSize", String(pageSize));
    return await get(`userprofile/moderation/reports?${params.toString()}`);
}

export async function resolveModerationReport(reportId, action, note) {
    return await post({ action, note }, `userprofile/moderation/reports/${reportId}/resolve`);
}
